(function () {
  'use strict';
  function colourFamily(label) {
    var value = label.toLowerCase();
    if (/diy|odorless|quiet|custom design|mesh bag|^opp$/.test(value)) return null;
    var families = [
      ['Gold', /gold/], ['Silver', /silver/],
      ['Black', /black/], ['White', /white|ivory/], ['Grey', /gr[ae]y|graphite|charcoal/],
      ['Blue', /blue|navy|teal/], ['Green', /green|olive|sage/], ['Brown', /brown|coffee|camel/],
      ['Beige', /beige|khaki|bone|cream|oat/], ['Red', /red|burgundy|wine/],
      ['Pink', /pink|rose|coral/], ['Purple', /purple|platycodon/],
      ['Orange', /orange|apricot|rust/], ['Yellow', /yellow/]
    ];
    var match = families.find(function (family) { return family[1].test(value); });
    return match ? match[0] : null;
  }
  function init(root) {
    root.querySelectorAll('[data-ms-colors]:not([data-ready])').forEach(function (fieldset) {
      fieldset.dataset.ready = 'true';
      var groups = new Map();
      fieldset.querySelectorAll('[data-ms-color-source] input').forEach(function (input) {
        var family = colourFamily(input.dataset.label || input.value);
        if (!family) return;
        if (!groups.has(family)) groups.set(family, []);
        groups.get(family).push(input);
      });
      var target = fieldset.querySelector('[data-ms-color-groups]');
      Array.from(groups.keys()).sort().forEach(function (family) {
        var inputs = groups.get(family);
        var label = document.createElement('label');
        var checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.checked = inputs.some(function (input) { return input.checked; });
        checkbox.addEventListener('change', function () {
          inputs.forEach(function (input) { input.checked = checkbox.checked; });
        });
        label.append(checkbox, document.createTextNode(family));
        target.append(label);
      });
      fieldset.hidden = groups.size === 0;
    });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { colourFamily: colourFamily };
  if (typeof document !== 'undefined') {
    init(document);
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  }
}());
